<ng-container *ngIf="address$ | async as addresses; else loading">
  <shared-selection-table
    [from]="'ship-to'"
    [items]="addresses"
    [columns]="columns"
    [jsonItemName]="jsonItemName"
    tableTitle="{{ 'accountSelection.addressSelect.title' | cxTranslate }}"
    tableText="{{ 'accountSelection.addressSelect.text' | cxTranslate }}"
    (selectedItemOutput)="setItem($event)"
  >
  </shared-selection-table>
</ng-container>
<div class="d-flex justify-content-between align-items-center">
  <div class="actions m-t-20 mr-2">
    <button type="button" class="btn btn-outline-primary" (click)="skipModal()">{{ 'accountSelection.cancel' | cxTranslate }}</button>
  </div>
  <div class="actions m-t-20">
    <ng-container *ngIf="orgUnit$ | async as orgUnit">
      <button type="button" class="btn btn-outline-primary mr-2" (click)="backModal()" *ngIf="!orgUnit?.defaultAccount">
        {{ 'accountSelection.back' | cxTranslate }}
      </button>
    </ng-container>
    <button type="button" class="btn btn-primary" (click)="closeModal()" [disabled]="selectedItem === undefined">
      {{ 'accountSelection.continue' | cxTranslate }}
    </button>
  </div>
</div>

<ng-template #loading>
  <div class="cx-spinner"><cx-spinner></cx-spinner></div>
</ng-template>
